export class CashReceiptPaymentTypeResultDto {
    code: string;
    displayText: string;
}
